// extracted by mini-css-extract-plugin
module.exports = {"full-width-image-wrapper":"VideoPlayer_full-width-image-wrapper__I9_Ut"};